import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component(resolve) { require(["@/views/home/index"], resolve); },
    meta: { title: "电影/影院", keepAlive: true, },
  },

  {
    path: "/movie-detail2",
    name: "movie-detail2",
    component(resolve) {
      require(["@/views/movie/movie-detail2"], resolve);
    },
    meta: { title: "电影详情" },
  },

  {
    path: "/search",
    name: "search",
    component(resolve) {
      require(["@/views/search"], resolve);
    },
    meta: { title: "搜索" },
  },
  {
    path: "/city",
    name: "city",
    component(resolve) {
      require(["@/views/city"], resolve);
    },
    meta: { title: "城市列表" },
  },
  {
    path: "/location-view",
    name: "location-view",
    component(resolve) {
      require(["@/views/address/location-view"], resolve);
    },
    meta: { title: "查看位置" },
  },

  {
    path: "/cinema",
    name: "cinema",
    component(resolve) {
      require(["@/views/cinema"], resolve);
    },
    meta: { title: "影院列表" },
  },
  {
    path: "/movie-session",
    name: "movie-session",
    component(resolve) {
      require(["@/views/cinema/movie-session"], resolve);
    },
    meta: { title: "电影场次" },
  },
  {
    path: "/cinema-seat",
    name: "cinema-seat",
    component(resolve) {
      require(["@/views/cinema/cinema-seat"], resolve);
    },
    meta: { title: "影院选座" },
  },

  {
    path: "/error",
    name: "error",
    component(resolve) {
      require(["@/views/error-page"], resolve);
    },
    meta: { title: "请求错误 C" },
  },
  {
    path: "*",
    name: "error404",
    component(resolve) {
      require(["@/views/error-page/404"], resolve);
    },
    meta: { title: "错误404" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/movie",
  routes,
});

router.beforeEach((to, from, next) => {
  // budo_log.info("#56 beforeEach", to, from)

  let title = to.meta ? to.meta.title : "";
  document.title = title;
  store.commit("setTitle", title);

  if (from.query.flag) {
    to.query.flag = from.query.flag;
  }

  next();
});

export default router;
